import { Link } from "react-router-dom";
import { navLinks, siteEmail, siteTagline, reportScopes } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-accent-950 text-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg flex items-center justify-center font-heading text-lg font-bold bg-primary-500 text-background-50">
                爆
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">爆料直播</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/90 max-w-md">
              专注直播争议举报与处理公示的公开平台。提供画面中断反馈、主播违规投诉、争议事件全程跟踪与平台处理结果同步，让每一条线索都被认真对待。
            </p>
            <p className="mt-3 text-xs tracking-[0.18em] text-accent-300">{siteTagline}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/report"
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-live-line" aria-hidden="true"></i>
                进入举报通道
              </Link>
              <Link
                to="/results"
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium border border-background-100/25 text-background-100 hover:bg-white/10 transition-colors whitespace-nowrap"
              >
                查看处理结果
              </Link>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h2 className="font-heading text-sm font-bold text-background-50 tracking-wide">站点导航</h2>
            <ul className="mt-4 space-y-2.5 text-sm">
              {navLinks.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-background-200/90 hover:text-background-50 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h2 className="font-heading text-sm font-bold text-background-50 tracking-wide">受理范围</h2>
            <ul className="mt-4 space-y-2.5 text-sm">
              {reportScopes.map((scope) => (
                <li key={scope.title}>
                  <Link
                    to="/report"
                    className="text-background-200/90 hover:text-background-50 transition-colors"
                  >
                    {scope.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h2 className="font-heading text-sm font-bold text-background-50 tracking-wide">联系我们</h2>
            <ul className="mt-4 space-y-3 text-sm text-background-200/90">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-300" aria-hidden="true"></i>
                <span className="break-all">{siteEmail}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-300" aria-hidden="true"></i>
                <span>受理时间：每日 09:00 – 22:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-accent-300" aria-hidden="true"></i>
                <span>举报人信息严格保密</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs text-background-300/80">
          <p>© {year} 爆料直播 · 直播争议举报与处理公示平台</p>
          <p className="max-w-2xl leading-relaxed">
            本站公示内容依据可核验的事件信息整理，处理结果以平台核查结论为准。如需引用请注明来源。
          </p>
        </div>
      </div>
    </footer>
  );
}